import { gql } from 'graphql-request';

//Sample movie query
export const RECOMMENDED_MOVIES_QUERY = gql`
  query ($filter: RecommendedFilter) {
    recommended(filter: $filter) {
      id
      title
      originalTitle
      tags
      modelName
      assetSubType
      contentType
      webSideBarFlag
      contents {
        ... on Movie {
          id
          title
          originalTitle
          businessType
          duration
          slug
          genres {
            id
            value
          }
          languages
          description
          assetType
          assetSubType
          releaseDate
          slug
          image {
            list
            cover
            sticker
            svodCover
          }
          actors
          ageRating
          audioLanguages
          subtitleLanguages
        }
      }
    }
  }
`;
